import { notification } from 'antd'
import axios from './axiosInstance'
import constants from '../constants'
import { handleErrors, definedErrorCodes } from '../helpers'

export default function init() {
  console.log('teams init')
}

export async function collaborators(app, pageNo = 1, searchText = '') {
  return axios
    .get(
      `${constants.customerDomain}apps/${app.id}/collaborators?per_page=${constants.perPageInListings}&page=${pageNo}&searchKey=${searchText}`,
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorMsgs = handleErrors('')
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      } else if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      }
      return errorObj
    })
}

export async function search(app, searchText, pageNo = 1) {
  return axios
    .get(
      `${constants.customerDomain}apps/${app.id}/collaborators?per_page=${constants.perPageInListings}&page=${pageNo}&searchKey=${searchText}`,
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      }
      return errorObj
    })
}

export async function invite(post, app) {
  return axios
    .post(`${constants.customerDomain}apps/${app.id}/collaborators`, post)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      }
      return errorObj
    })
}

export async function remove(post, app) {
  return axios
    .post(`${constants.customerDomain}apps/${app.id}/collaborators`, post)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      }
      return errorObj
    })
}

export async function changeRole(post, app) {
  return axios
    .post(`${constants.customerDomain}apps/${app.id}/collaborators`, post)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      }
      return errorObj
    })
}

export async function leave(app) {
  return axios
    .delete(`${constants.customerDomain}apps/${app.id}/collaborators`)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      }
      return errorObj
    })
}

export async function transferOwnership(post, app) {
  return axios
    .patch(`${constants.customerDomain}apps/${app.id}/owner`, post)
    .then(res => {
      return res.data
    })
    .catch(error => {
      let errorObj = {
        error: true,
        errDescription: error.response.data.error.message,
        errMessage: 'App Not Found!',
      }
      let errorMsgs = handleErrors('')
      if (
        error.response &&
        error.response.data.error.code !== undefined &&
        definedErrorCodes(error.response.data.error.code)
      ) {
        errorMsgs = handleErrors(error.response.data.error.code)
        notification.warning({
          message: errorMsgs.message,
          description: errorMsgs.description,
        })
      } else if (
        error.response !== undefined &&
        error.response.data !== undefined &&
        error.response.data.error.code !== undefined &&
        error.response.data.error.code === 'ERR_APP_NOT_FOUND'
      ) {
        errorObj = {
          error: true,
          errDescription: error.response.data.error.message,
          errMessage: 'App Not Found!',
        }
      }
      return errorObj
    })
}
